import { render } from "./LanguageManager.vue?vue&type=template&id=5d3319d0"
import script from "./LanguageManager.vue?vue&type=script&lang=js"
export * from "./LanguageManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__